import { __awaiter } from "tslib";
import { doFetch } from './http-client';
import { getCardsApiUrl } from './transferState-service';
const BASE_FLASHCARDS_API_URL = getCardsApiUrl() + "/api";
const FLASHCARDS_FAVORITE_CARDSETS = `${BASE_FLASHCARDS_API_URL}/cardsets`;
const FLASHCARDS_FAVORITE_CARDS_ENDPOINT = `${FLASHCARDS_FAVORITE_CARDSETS}/favorite/cards`;
const FLASHCARDS_FAVORITE_EXISTS_ENDPOINT = `${FLASHCARDS_FAVORITE_CARDS_ENDPOINT}/exists`;
export function markTranslationFavorite(_a) {
    return __awaiter(this, arguments, void 0, function* ({ l1, l2, phrase, translation }) {
        const requestData = {
            card: {
                side1: {
                    language: l1,
                    text: phrase,
                },
                side2: {
                    language: l2,
                    text: translation,
                },
            },
        };
        return doFetch(FLASHCARDS_FAVORITE_CARDS_ENDPOINT, {
            body: JSON.stringify(requestData),
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        });
    });
}
export function checkIfTranslationsAreMarkedAsFavorite(_a) {
    return __awaiter(this, arguments, void 0, function* ({ l1, l2, phrase, translations }) {
        const requestData = {
            l1: l1,
            l2: l2,
            p1: phrase,
            p2: translations
        };
        return doFetch(FLASHCARDS_FAVORITE_EXISTS_ENDPOINT, {
            body: JSON.stringify(requestData),
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        });
    });
}
export function removeFavoriteTranslation(_a) {
    return __awaiter(this, arguments, void 0, function* ({ l1, l2, phrase, translation }) {
        const params = new URLSearchParams();
        params.set("l1", l1);
        params.set("l2", l2);
        params.set("p1", phrase);
        params.set("p2", translation);
        return doFetch(FLASHCARDS_FAVORITE_CARDS_ENDPOINT + "?" + params.toString(), {
            method: "DELETE",
            credentials: "include"
        });
    });
}
export function getFavoriteTranslations(_a) {
    return __awaiter(this, arguments, void 0, function* ({ l1, l2 }) {
        const params = new URLSearchParams();
        params.set("l1", l1);
        params.set("l2", l2);
        return doFetch(FLASHCARDS_FAVORITE_CARDS_ENDPOINT + "?" + params.toString(), {
            method: "GET",
            credentials: "include"
        });
    });
}
export function getFavoriteTranslationsCardsets() {
    return __awaiter(this, void 0, void 0, function* () {
        return doFetch(FLASHCARDS_FAVORITE_CARDSETS, {
            method: "GET",
            credentials: "include"
        });
    });
}
